import DefaultProfile from "../../images/v2/Profiles.svg";
import { useAppConfig } from "@/appConfig";

const AgentProfileCard = ({
  isAgentCreated,
  userAvatar,
  userFirstName,
  userLastName,
  userCompany,
  showAvatar = true,
  showCompany = true,
  showProBadge = true,
  namePrefix = "",
  companySuffix = "",
  avatarSize = "35px",
  avatarWrapperClassName = "property-agent-profile-wrap",
  avatarClassName = "property-agent-profile",
  onAvatarClick,
  linkComponent,
  fallback,
}) => {
  const { flags } = useAppConfig();

  if (!isAgentCreated) {
    return fallback || null;
  }

  return (
    <>
      {showAvatar && (
        <div className={avatarWrapperClassName}>
          <img
            src={userAvatar || DefaultProfile}
            alt="avatar"
            className={`${avatarClassName}${onAvatarClick ? " pe-auto" : ""}`}
            width={avatarSize}
            height={avatarSize}
            {...(onAvatarClick && { role: "button", onClick: onAvatarClick })}
          />
        </div>
      )}
      <div className="property-agent-details">
        <div className="property-agent-name">
          {namePrefix}{userFirstName} {userLastName}
          {showProBadge && flags.proBadge ? <span className="pro-tag">PRO</span> : null}
        </div>
        {showCompany && (
          <div className="property-agent-requested-infoo">
            {`Agent @ ${userCompany}${companySuffix}`}
            {linkComponent}
          </div>
        )}
      </div>
    </>
  );
};

export default AgentProfileCard;
